import EAFDataEntry from "../../pages/eaf/data-entry";
import EAFProcesses from "../../pages/eaf/eaf-processes";
import RoofPanel from "../../pages/eqp/eaf/roof";
import SidewallPanel from "../../pages/eqp/eaf/sidewall";
import ProductionReport from "../../pages/production-report";
import { RouteConfig } from "./types";

// Define EAF routes with flat structure
export const eafRoutes: RouteConfig[] = [
  {
    path: "/eaf-processes",
    element: <EAFProcesses />,
    permission: "ui.navbar.eaf.processes",
  },
  {
    path: "/eaf-processes/:shiftId",
    element: <EAFProcesses />,
    permission: "ui.navbar.eaf.processes",
  },
  {
    path: "/production-report",
    element: <ProductionReport />,
    permission: "ui.navbar.eaf.processes",
  },
  {
    path: "/eaf-data-entry",
    element: <EAFDataEntry />,
    permission: "ui.navbar.eaf.data-entry",
  },
  {
    path: "/eaf-data-entry/:processId",
    element: <EAFDataEntry />,
    permission: "ui.navbar.eaf.data-entry",
  },
  {
    path: "/eaf-roof-panel",
    element: <RoofPanel />,
    permission: "ui.navbar.eaf.roof-panel",
  },
  {
    path: "/eaf-sidewall",
    element: <SidewallPanel />,
    permission: "ui.navbar.eaf.sidewall",
  },
];
